import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { Row, Modal, Alert } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OPP_CONSTANTS } from "../../constants/OppContants";
import "../../MediaPreview.css";
import AttachmentComponent from "./AttachmentComponent";

function ModelPopup({
  orderId,
  show,
  showUpload,
  iconName,
  iconColor,
  title,
  placeholder,
  okTitle,
  okDisabled,
  cancelTitle,
  hasInput,
  showLoading,
  errMessage,
  uploadedMediaFiles,
  handleClose,
  handleOkClick,
  handleUploadSuccess,
}) {
  const [showPopup, setShowPopup] = useState(false);
  const [showUploads, setShowUploads] = useState(false);
  const [inputText, setInputText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMessage] = useState(null);

  const handleChange = (e) => setInputText(e.target.value);

  useEffect(() => {
    setShowUploads(showUpload);
  }, [showUpload]);

  useEffect(() => {
    setErrorMessage(errMessage);
  }, [errMessage]);

  useEffect(() => {
    setShowPopup(show);
  }, [show]);

  useEffect(() => {
    setIsLoading(showLoading);
  }, [showLoading]);

  const handleOkSubmit = () => {
    setErrorMessage(null);
    handleOkClick(inputText);
  };

  const onHandleClose = () => {
    if (!isLoading) {
      setInputText("");
      setErrorMessage(null);
      handleClose();
    }
  };

  return (
    <Modal
      open={showPopup}
      destroyOnClose={true}
      title={
        <Row className="hardware-info-row" style={{ justifyContent: "start" }}>
          {iconName && (
            <FontAwesomeIcon
              icon={iconName}
              color={iconColor ?? "gray"}
              size="2x"
              style={{ paddingRight: "15px" }}
            />
          )}
          <span className="summary-value">{title ?? "Warning"}</span>
        </Row>
      }
      onCancel={onHandleClose}
      footer={[
        <div key={"footer_model_popup"} className="opp-button-container">
          <div key={"footer_model_popup_inner"} style={{ display: "flex" }}>
            {cancelTitle && (
              <div className="opp-button">
                <Button
                  variant="secondary"
                  onClick={onHandleClose}
                  disabled={isLoading}
                >
                  {cancelTitle}
                </Button>
              </div>
            )}
            {okTitle && (
              <div className="opp-button">
                <Button
                  onClick={handleOkSubmit}
                  disabled={
                    okDisabled || isLoading || (hasInput && inputText.trim().length === 0)
                  }
                >
                  {isLoading ? "Loading..." : okTitle}
                </Button>
              </div>
            )}
          </div>
        </div>,
      ]}
    >
      <>
        {hasInput ? (
          <Form.Control
            className="custom-placeholder-color"
            as="textarea"
            rows={4}
            value={inputText}
            onChange={handleChange}
            placeholder={placeholder ?? "Please Enter Serial ID"}
          />
        ) : (
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {placeholder}
          </div>
        )}

        {showUploads && (
          <AttachmentComponent
            orderId={orderId}
            okTitle={OPP_CONSTANTS.btns.upload}
            uploadedMediaFiles={uploadedMediaFiles}
            handleUploadSuccess={handleUploadSuccess}
          />
        )}

        <div style={{ paddingTop: "10px" }}>
          {errorMsg && <Alert message={errorMsg} type="error" showIcon />}
        </div>
      </>
    </Modal>
  );
}

export default ModelPopup;
